import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactPopup from '../components/ContactPopup';

const Career = () => {
  const [popupState, setPopupState] = useState({
    isOpen: false,
    title: "Connect With Us",
    subtitle: "Share your interest in working with the 1to10x team",
    formType: "career",
    interestedProgram: ""
  });

  const openPopup = (config: {
    title?: string;
    subtitle?: string;
    formType?: string;
    interestedProgram?: string;
  } = {}) => {
    setPopupState({
      isOpen: true,
      title: config.title || "Connect With Us",
      subtitle: config.subtitle || "Share your interest in working with the 1to10x team",
      formType: config.formType || "career",
      interestedProgram: config.interestedProgram || ""
    });
  };

  const closePopup = () => {
    setPopupState(prev => ({ ...prev, isOpen: false }));
  };

  const values = [
    {
      title: "Learning First",
      description: "We build experiences that help professionals practice, experiment, and grow with confidence."
    },
    {
      title: "Practical Craft",
      description: "Our work is grounded in real projects, useful feedback, and thoughtful execution."
    },
    {
      title: "Calm Collaboration",
      description: "We value clear communication, ownership, and respect for deep work."
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header openPopup={openPopup} />

      <section className="relative bg-gray-900 text-white py-20 overflow-hidden">
        <div className="relative z-10 max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Build Meaningful Learning Experiences With <span className="text-blue-300">1to10x</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed mb-8">
            We are focused on practical education, thoughtful mentorship, and tools that help professionals grow.
          </p>
          <button
            onClick={() => openPopup()}
            className="bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-gray-100 transition-all duration-200 transform hover:scale-105"
          >
            Connect With Us
          </button>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              How We <span className="text-purple-600">Work</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We care about useful learning, high standards, and a collaborative team culture.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-sm">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />

      <ContactPopup
        isOpen={popupState.isOpen}
        onClose={closePopup}
        title={popupState.title}
        subtitle={popupState.subtitle}
        formType={popupState.formType}
        interestedProgram={popupState.interestedProgram}
      />
    </div>
  );
};

export default Career;
